module.exports = __webpack_public_path__ + "img/ZJ5227.e6104856.png";